(function(){
  'use strict';
  var colorNames = ['skin','skin tone','beige','cream','ivory','off white','white','black','grey','gray','charcoal','brown','khaki','tan'];
  function norm(v){ return String(v||'').toLowerCase().replace(/[\u2019']/g,'').replace(/[-_]+/g,' ').replace(/\s+/g,' ').trim(); }
  function getColorText(el){
    var parts=[];
    if(el){
      parts.push(el.getAttribute && el.getAttribute('data-value'));
      parts.push(el.getAttribute && el.getAttribute('value'));
      parts.push(el.getAttribute && el.getAttribute('aria-label'));
      parts.push(el.getAttribute && el.getAttribute('title'));
      parts.push(el.textContent);
      var forId=el.getAttribute && el.getAttribute('for');
      if(forId){ var x=document.getElementById(forId); if(x) parts.push(x.value,x.getAttribute('data-value'),x.getAttribute('aria-label')); }
    }
    return norm(parts.filter(Boolean).join(' '));
  }
  function isColorControl(el){
    var p=el.closest && el.closest('.hdt-product-form__input,[data-option],[data-option-name],[data-product-option],hdt-variant-option,fieldset');
    if(!p) return false;
    var t=norm(p.getAttribute('data-option-name')||p.getAttribute('data-option')||p.getAttribute('name')||p.textContent);
    return t.indexOf('color')>=0 || t.indexOf('colour')>=0;
  }
  function images(){ return Array.from(document.querySelectorAll('hdt-product-media img, .hdt-product-media__main img, .hdt-product-media img')); }
  function showImage(index){
    var imgs=images().filter(function(i){return i.offsetParent!==null || i.closest('.hdt-slider__slide');});
    if(!imgs.length) return;
    var img=imgs[index] || imgs[0];
    var slide=img.closest('.hdt-slider__slide');
    var thumb=img.closest('.hdt-product-media__main') && document.querySelectorAll('hdt-slider-thumb img')[index];
    if(thumb){ var tp=thumb.closest('.hdt-slider__slide,button,a'); if(tp && tp.click) tp.click(); else if(thumb.click) thumb.click(); }
    if(slide){ slide.removeAttribute('hidden'); slide.classList.add('is-selected'); if(slide.scrollIntoView) slide.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'}); }
    if(img && img.scrollIntoView && window.innerWidth<768) img.scrollIntoView({behavior:'smooth',block:'nearest'});
  }
  function matchImage(color){
    var c=norm(color);
    if(!c) return;
    var imgs=images();
    for(var i=0;i<imgs.length;i++){
      var hay=norm((imgs[i].alt||'')+' '+(imgs[i].currentSrc||imgs[i].src||''));
      if(hay && hay.indexOf(c)>=0){ showImage(i); return; }
    }
    if(c.indexOf('skin')>=0 || c.indexOf('beige')>=0 || c.indexOf('cream')>=0 || c.indexOf('ivory')>=0 || c.indexOf('tan')>=0 || c.indexOf('khaki')>=0 || c.indexOf('brown')>=0){ showImage(0); return; }
    if(c.indexOf('white')>=0 || c.indexOf('off white')>=0){ showImage(1); return; }
    if(c.indexOf('black')>=0 || c.indexOf('grey')>=0 || c.indexOf('gray')>=0 || c.indexOf('charcoal')>=0){ showImage(2); return; }
  }
  function bind(root){
    var controls=(root||document).querySelectorAll('input[type=radio],input[type=checkbox],select option,button,label,[role=radio]');
    controls.forEach(function(el){
      if(el.dataset && el.dataset.vgColorBound) return;
      if(el.dataset) el.dataset.vgColorBound='1';
      var handler=function(){
        if(!isColorControl(el)) return;
        var text=getColorText(el);
        if(text && colorNames.some(function(n){return text.indexOf(n)>=0;})) setTimeout(function(){matchImage(text);},80);
      };
      el.addEventListener('change',handler,{passive:true});
      el.addEventListener('click',handler,{passive:true});
    });
  }
  bind(document);
  var mo=new MutationObserver(function(){ bind(document); });
  mo.observe(document.documentElement,{subtree:true,childList:true});
})();